module.exports = __webpack_public_path__ + "static/img/2_12_1.a7667a1c.jpg";